/** * Created by vouill on 11/13/17. */

<template>
  <div>
  <navbar></navbar>
    <div class="headline">
      <img src="../assets/images/dog-profile.jpeg" />
      <h1>Your doge profile</h1>
    </div>
    <p v-if="profile.name">
      <strong>Name:</strong> {{ profile.title }} {{ profile.name }}
    </p>
  </div>
</template>

<style >
.headline {
  margin-top: 1em;
  display: flex;
  img {
    height: 80px;
    width: 80px;
    border-radius: 50%;
  }
}
</style>

<script>
import { mapState } from "vuex";
import Navbar from "./features/Navbar"

export default {
  name: "account",
  components: {
  Navbar,
  },
  computed: mapState({ profile: state => state.user.profile })
};
</script>



// WEBPACK FOOTER //
// src/components/Account.vue